import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, MessageCircle } from "lucide-react";
import { Logo } from "./Logo";
import { useStore } from "@/context/StoreContext";
import { toast } from "sonner";

const COLS = [
  { title: "HELP", links: [["Contact", "/contact"], ["Track Order", "/track-order"], ["Shipping", "/shipping-policy"], ["Size Guide", "/size-guide"], ["Returns", "/return-policy"], ["Refund Policy", "/return-policy"], ["FAQ", "/faq"]] },
  { title: "COMPANY", links: [["About SHAROA", "/about"], ["Our Story", "/about"], ["Reviews", "/reviews"]] },
];

export default function Footer() {
  const [email, setEmail] = useState("");
  const { categories } = useStore();
  const shopLinks = [...(categories || []).slice().sort((a, b) => (a.order ?? 99) - (b.order ?? 99)).slice(0, 5).map((c) => [c.name, `/shop/${c.slug}`]), ["Collections", "/collections"]];
  const cols = [{ title: "SHOP", links: shopLinks }, ...COLS];
  const subscribe = (e) => { e.preventDefault(); if (email) { toast("Welcome to the SHAROA world ♡"); setEmail(""); } };
  return (
    <footer className="bg-sharoa-ivory border-t border-sharoa-line mt-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-14 grid grid-cols-2 md:grid-cols-5 gap-8">
        <div className="col-span-2">
          <Logo className="h-20 sm:h-24" />
          <p className="mt-4 font-serif italic text-sharoa-muted text-lg">Modern femininity, beautifully worn.</p>
          <div className="flex items-center gap-4 mt-5">
            <a href="https://instagram.com/sharoaofficial" target="_blank" rel="noreferrer" data-testid="footer-instagram" className="text-sharoa-charcoal hover:text-sharoa-rose"><Instagram size={20} /></a>
            <a href="https://wa.me/919000000000" target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="text-sharoa-charcoal hover:text-sharoa-rose"><MessageCircle size={20} /></a>
            <a href="https://facebook.com/sharoaofficial" target="_blank" rel="noreferrer" data-testid="footer-facebook" className="text-sharoa-charcoal hover:text-sharoa-rose"><Facebook size={20} /></a>
          </div>
        </div>
        {cols.map((c) => (
          <div key={c.title}>
            <h4 className="text-xs uppercase tracking-[0.16em] text-sharoa-charcoal font-sans font-semibold mb-4">{c.title}</h4>
            <ul className="space-y-2.5">
              {c.links.map(([label, to]) => (
                <li key={label + to}><Link to={to} className="text-sm text-sharoa-muted hover:text-sharoa-rose transition-colors">{label}</Link></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 pb-14">
        <div className="border-t border-sharoa-line pt-10 max-w-xl">
          <h4 className="font-serif text-2xl text-sharoa-charcoal mb-2">JOIN THE SHAROA WORLD ♡</h4>
          <p className="text-sm text-sharoa-muted mb-4">Be the first to know about new drops, exclusive offers and more.</p>
          <form onSubmit={subscribe} className="flex gap-2">
            <input data-testid="newsletter-input" value={email} onChange={(e) => setEmail(e.target.value)} type="email" required placeholder="Your email address"
              className="flex-1 border border-sharoa-line bg-white px-4 py-3 text-sm outline-none focus:border-sharoa-rose" />
            <button data-testid="newsletter-submit" className="bg-sharoa-rose hover:bg-sharoa-rosedark text-white text-xs uppercase tracking-widest px-6 py-3 transition-colors">Subscribe</button>
          </form>
        </div>
      </div>
      <div className="border-t border-sharoa-line py-5 text-center text-xs text-sharoa-muted">
        © {new Date().getFullYear()} SHAROA. Modern femininity, beautifully worn.
      </div>
    </footer>
  );
}
